import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import css from './index.module.scss';
import Banner from './components/Banner';
import TextA from './components/TextA';
import ImgTextB from './components/ImgTextB';
import ImgTextC from './components/ImgTextC';
import SwitchTabD from './components/SwitchTabD';
import ImgE from './components/ImgE';
import TextIconF from './components/TextIconF';
import ImgG from './components/ImgG';
import ProgressH from './components/ProgressH';
import SliderI from './components/SliderI';
import CardsIconJ from './components/CardsIconJ';
import ImgTextK from './components/ImgTextK';
import CardImgL from './components/CardImgL';
import ImgTextM from './components/ImgTextM';
import SwitchTabN from './components/SwitchTabN';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OtherList from '@/components/ProductCommon/OtherList';

export default function Dg200() {
    const { isMobile, gloproductlist, useRouter } = useGlobal();
    const { locale } = useRouter();
    const others = ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'];
    if (locale === 'au') {
        others.push('product_ps_river_river_256');
    }
    const otherProduts = getDetaileMoreProducts(gloproductlist, others);

    // 这一段必须要先于子组件触发
    if (typeof window !== 'undefined' && typeof ScrollMagic == 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    return (
        <div className={`dg200 ${css.dg200} ${isMobile ? 'dg200_h5' : 'dg200_pc'}`}>
            <Banner />
            <TextA />
            <ImgTextB />
            <ImgTextC />
            <SwitchTabD />
            <ImgE />
            <TextIconF />
            <ImgG />
            <ProgressH />
            <SliderI />
            <CardsIconJ />
            <SwitchTabN />
            <ImgTextK />
            <CardImgL />
            <ImgTextM />
            <OtherList theme="black" data={otherProduts} />
        </div>
    );
}
